// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Storage from 'vue-ls';
import store from './store';
import io from 'socket.io-client';
import VueSocketio from 'vue-socket.io';
import { chatroomServer } from './config.json';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from 'vue-notification';
import 'reset-css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSignOutAlt,
  faImage,
  faArrowRight,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.use(Storage);
Vue.use(
  VueSocketio,
  io(chatroomServer, {
    forceNew: true,
    autoConnect: false
  })
);
Vue.use(VueAxios, axios);
library.add(faSignOutAlt, faImage, faArrowRight, faSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(Notifications);
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  // el: '#app',
  store
  // template: '<App/>',
  // components: { App }
}).$mount('#app');
